<template>
  <div>
    <v-navigation-drawer v-model="drawer" fixed app>
      <v-list dense>
        <v-list-tile
          value="true"
          v-for="(item, i) in items"
          :key="i"
          @click="menuOption(item.action, item.value || false)"
        >
          <v-list-tile-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="blue lighten-1" dark fixed app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>Gestor Documental Usuarios</v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: "Navigation",
  data() {
    return {
      drawer: false,
      vista: "expedientes"
    };
  },
  computed: {
    items() {
      return this.$store.getters.getItemsMenu;
    },
    level() {
      return this.$store.getters.getLevel;
    }
  },
  methods: {
    menuOption(option, value = "profile") {
      switch (option) {
        case "logout":
          this.$auth.signOut();
          this.$router.replace("/");
          break;
        case "vista":
          this.vista = value;
          this.$router.replace(value);
          break;
        default:
          break;
      }
    }
  }
};
</script>
